<div class="wrapper">
  <div class="top-bar">
    <div class="content-center">
      <a (click)="navigateHomePage()"
        class="text-blue-100 hover:text-white focus:text-white focus:outline-white font-medium leading-tight text-base no-underline flex items-center">
        <img class="back-icon" src="assets/images/icon/StartOver.svg" />
        {{ translations['restart'] }}</a>
    </div>
    <div class="logo-div">
      <img src="assets/images/ecolab-logo-white-app-header.png" alt="EcoLab Logo" class="logo" />
    </div>
    <div class="content-end">
      <select [value]="currentLanguage" (change)="languageChange($event)" class="select-dropdown">
        <option *ngFor="let option of languageOptions" [value]="option?.value"
          [selected]="option.value === currentLanguage">
          {{ option.value }}
        </option>
      </select>
    </div>
  </div>
  <div class="main pt-1">
    <div class="max-w-xl mx-auto pt-2 px-4">
      <h1 class="h1">{{ translations['training_page_header'] }}</h1>

      <ng-container *ngFor="let video of trainingVideos">
        <h2 class="h2 text-black">{{ translations[video.titleKey] }}</h2>
        <iframe class="aspect-video w-full mb-12"
          [src]="video.safeUrls?.[currentLanguageCode] || video.safeUrls?.['en']" [title]="video.title" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen="" [attr.data-gtm-yt-inspected-6]="true"></iframe>
      </ng-container>
    </div>
  </div>
</div>